<app-page-header>
    {{ 'Property Management Companies' }}
    <!-- TODO: implement adding pmc feature -->
    <!--a *ngIf="dataTable.hasData"
       mat-fab extended disableRipple color="primary"
       [attr.aria-label]="routerAddButton.ariaLabel"
       [routerLink]="routerAddButton.route">
        <mat-icon [svgIcon]="'v2:fi-br-plus'"></mat-icon>
        {{ routerAddButton.label }}
    </a-->
</app-page-header>

<app-table #dataTable
           class="pmc-list-table"
           [columnMap]="columnMap"
           [columnSort]="columnSort"
           [type]="tableType"
           [rowSelectable]="true"
           (rowSelect)="goToPmc($event)"
           (showFilters)="openFilters($event)"
           (loaded)="hasData = $event.data.length > 0"
           matSort
           matSortActive="name"
           matSortDirection="asc"
           matSortDisableClear="true">
    <ng-container matColumnDef="mobile">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{ columnMap[0].title }}</mat-header-cell>
        <mat-cell *matCellDef="let row" [emptyCell]="!row.name">
            <app-avatar-block [initials]="row.initials">
                <a [routerLink]="['..', row.id]" avatarTitle>{{ row.name }}</a>
                <span avatarDescription>{{ row.organizations.length | i18nPlural: organizationsMapping }}</span>
            </app-avatar-block>
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{ columnMap[1].title }}</mat-header-cell>
        <mat-cell *matCellDef="let row" [emptyCell]="!row.name">
            <app-avatar-block [initials]="row.initials">
                <a [routerLink]="['..', row.id]" avatarTitle>{{ row.name }}</a>
                <span avatarDescription>{{ row.organizations.length | i18nPlural: organizationsMapping }}</span>
            </app-avatar-block>
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="emails">
        <mat-header-cell *matHeaderCellDef>{{ columnMap[2].title }}</mat-header-cell>
        <mat-cell *matCellDef="let row" [emptyCell]="!row.users">
            <span>
                <ng-container *ngFor="let user of row.users; let isLast = last">
                    <span class="no-wrap" [innerHTML]="user.email + (!isLast ? ',' : '')"></span>
                </ng-container>
            </span>
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="regions">
        <mat-header-cell *matHeaderCellDef>{{ columnMap[3].title }}</mat-header-cell>
        <mat-cell *matCellDef="let row" [emptyCell]="row.orgCityStates.length === 0">
            <span *ngFor="let cityState of row.orgCityStates" [innerHTML]="cityState | addressLine: true: false"></span>
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="unitsCount">
        <mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before" numberCell>
            <span class="no-wrap">{{ columnMap[4].title }}</span>
        </mat-header-cell>
        <mat-cell *matCellDef="let row" [emptyCell]="!row.unitsCount" useZero="true" numberCell>
            {{ row.unitsCount | number:'1.0':'en-US' }}
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="membersCount">
        <mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before" numberCell>
            <span class="no-wrap">{{ columnMap[5].title }}</span>
        </mat-header-cell>
        <mat-cell *matCellDef="let row" [emptyCell]="!row.membersCount" useZero="true" numberCell>
            {{ row.membersCount | number:'1.0':'en-US' }}
        </mat-cell>
    </ng-container>

    <app-empty-state [icon]="'communities'">
        <span emptyStateTitle>{{ 'No property management companies so far...' }}</span>
        <!--a mat-fab extended disableRipple color="primary"
           [attr.aria-label]="routerAddButton.ariaLabel"
           [routerLink]="routerAddButton.route">
            <mat-icon [svgIcon]="'v2:fi-br-plus'"></mat-icon>
            {{ routerAddButton.label }}
        </a-->
    </app-empty-state>
</app-table>
